function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.9765 10.4368L10.2444 3.31246C11.1795 2.39585 12.6962 2.39585 13.6313 3.31246L14.602 4.26405C15.5371 5.18066 15.5371 6.66738 14.602 7.584L7.30546 14.7364C6.88823 15.1454 6.32255 15.3749 5.73211 15.3749H2.74391C2.46631 15.3749 2.24324 15.1507 2.25016 14.8787L2.32532 11.9231C2.34027 11.3645 2.57345 10.8319 2.9765 10.4368ZM13.9036 4.94873L12.9328 3.99715C12.3835 3.45867 11.4922 3.45867 10.9429 3.99715L10.3787 4.55023L13.3396 7.45209L13.9036 6.89932C14.4529 6.36084 14.4529 5.48721 13.9036 4.94873ZM3.67498 11.1215L9.68019 5.23492L12.6412 8.13678L6.60697 14.0518L6.52671 14.1238C6.30503 14.3059 6.02417 14.4066 5.73211 14.4066L3.25009 14.4063L3.31281 11.9478C3.3211 11.6377 3.45095 11.3411 3.67498 11.1215ZM15.75 14.8909C15.75 14.6235 15.5289 14.4067 15.2561 14.4067H10.1032L10.0362 14.4111C9.79515 14.4432 9.60934 14.6458 9.60934 14.8909C9.60934 15.1582 9.83047 15.375 10.1032 15.375H15.2561L15.3231 15.3706C15.5642 15.3385 15.75 15.136 15.75 14.8909Z",
  fill: "#BABAC8"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.bc9efc2e.svg";
export { ForwardRef as ReactComponent };